import React from "react";

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const BlogImage = ({ src, alt, color, showActions = false, blog, handleEdit, handleDelete }) => {
  return (
    <div className={`blog-image ${color || ""}`}>
      <img src={src} alt={alt} />
      {showActions && (
        <>
          <div className="absolute top-2 right-12 z-8 bg-white/80 p-1 rounded-full shadow-md cursor-pointer hover:bg-white transition-colors"
            onClick={() => {handleEdit(blog)}}>
            <EditIcon className="w-4 h-4 text-green-400" />
          </div>
          <div className="absolute top-2 right-2 z-8 bg-white/80 p-1 rounded-full shadow-md cursor-pointer hover:bg-white transition-colors"
            onClick={() => {handleDelete(blog)}}>
            <DeleteIcon className="w-4 h-4 text-red-400" />
          </div>
        </>
      )}

      {color !== "none" && (
        <div className={`image-overlay ${color}`} />
      )}
    </div>
  );
};

export default BlogImage;